import type { ColumnDef, TableFilter } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import { workOrderStatusByCode, workOrderStatuses } from "../../status-tags"

export type WorkOrderTableColumnDef = ColumnDef & {
  printable?: boolean
}

export const columns: WorkOrderTableColumnDef[] = [
  {
    id: "orderSummary",
    label: "Auftrag",
    tooltip: "Auftragstyp und Auftragsnummer kompakt zusammengefasst.",
    sortable: true,
    sortKey: "order_number",
    sortType: "number",
    defaultSortDir: "desc",
  },
  {
    id: "statusLabel",
    label: "Termin",
    tooltip: "Aktueller Termin und Stand seiner Vereinbarung oder Ankündigung.",
    sortable: true,
    sortKey: "active_appointment",
    sortType: "date",
    defaultSortDir: "desc",
  },
  {
    id: "propertyLabel",
    label: "Liegenschaft",
    tooltip: "Liegenschaft und Gebäude- oder Wohneinheit des Auftrags.",
    sortable: true,
    sortKey: "address",
    sortType: "text",
  },
  {
    id: "actionRequiredLabel",
    label: "Aktion",
    tooltip: "Zeigt, ob der Betrieb für diesen Auftrag aktuell manuell handeln muss.",
    sortable: true,
    sortKey: "action_required",
    sortType: "number",
    defaultSortDir: "desc",
  },
  {
    id: "recipientLabel",
    label: "Ansprechpartner",
    sortable: true,
    sortKey: "customer",
    sortType: "text",
  },
  {
    id: "billedCreditsLabel",
    label: "Credits",
    tooltip: "Gesamte bereits abgerechnete Credits für Auftrag, Mobile Nachricht und Briefversand.",
    printable: false,
    sortable: true,
    sortKey: "billed_credits",
    sortType: "number",
  },
]

export { workOrderStatusByCode, workOrderStatuses }

export const filter: TableFilter[] = [
  {
    column: "orderNumber",
    type: "text",
    label: "Auftragsnr.",
    placeholder: "Nach Auftragsnummer filtern…",
  },
  {
    column: "statusRaw",
    type: "status",
    label: "Status",
    placeholder: "Status filtern…",
    multiple: true,
    statuses: workOrderStatuses,
    value: workOrderStatuses.map((entry) => entry.value),
  },
]
